export enum ValuableType {
    URV = 'URV',
    UCL = 'UCL',
    BILLABLE = 'BILLABLE'
}

export interface CommonValuableConceptResponse {
    active: boolean
    code: string
    description: string
    id: number
    name: string
    totalValue: number
}
